export default __webpack_public_path__ + "static/media/googleSheetsIcon.9a7e9adf.svg";